import _taggedTemplateLiteral from '../node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js';
import styled from 'styled-components';

var _templateObject, _templateObject2;
const InlineCodeDiv = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline;\n\n  // Copy icon\n  .InlineCode__copyBtn {\n    color: ", " !important;\n  }\n  .InlineCode__copyBtn:hover {\n    color: ", " !important;\n  }\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.colorCopyCodeIcon;
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.colorCopyCodeIconHover;
});
const InlineCodeContent = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-family: Monaco, Menlo, Consolas, 'Courier Prime', Courier, 'Courier New',\n    monospace;\n  color: ", ";\n  background: ", ";\n  white-space: normal;\n  padding: 0.125rem 0.5rem;\n  border: 1px solid ", ";\n"])), _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.colorInlineCodeText;
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.background;
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.colorCopyCodeBorder;
});

export { InlineCodeContent, InlineCodeDiv };
